import { createElement } from "react"
import { createRoot } from "react-dom/client"
import GraphWidget from "../components/GraphWidget.jsx"

let root = null
let currentElement = null

export function mountGraphWidget() {
  const element = document.getElementById("graph-widget")
  if (!element) return

  if (currentElement !== element) {
    root?.unmount()
    root = createRoot(element)
    currentElement = element
  }

  root.render(createElement(GraphWidget, { mountElement: element }))
}

export function unmountGraphWidget() {
  root?.unmount()
  root = null
  currentElement = null
}

function mountGraphWidgetIfStandalone() {
  if (document.querySelector("[data-controller~='research-panel']")) return

  mountGraphWidget()
}

document.addEventListener("graph-widget:mount", mountGraphWidget)
document.addEventListener("graph-widget:unmount", unmountGraphWidget)
document.addEventListener("turbo:load", mountGraphWidgetIfStandalone)

if (document.readyState !== "loading") {
  mountGraphWidgetIfStandalone()
} else {
  document.addEventListener("DOMContentLoaded", mountGraphWidgetIfStandalone)
}
